import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M15.05 12.81L6.56 4.32a.9959.9959 0 00-1.41 0L2.32 7.15c-.39.39-.39 1.02 0 1.41l8.49 8.49c.39.39 1.02.39 1.41 0l2.83-2.83c.39-.39.39-1.02 0-1.41zM14.3412 17.7562l1.4142-1.4142 4.2426 4.2426-1.4142 1.4142z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "18.5",
  cy: "5.5",
  r: "3.5"
})), 'SportsCricket');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SportsCricket.js
// module id = 6379
// module chunks = 2